<template>
    <button class="hamburger hamburger--elastic"
            aria-label="Menu"
            :class="{ 'is-active': isOpen }"
            :aria-expanded="isOpen ? 'true' : 'false'"
            @click="toggle">
        <span class="hamburger-box">
            <span class="hamburger-inner"/>
        </span>
    </button>
</template>

<script>
    import { mapActions, mapState } from 'vuex';

    export default {
        props: {},
        computed: {
            ...mapState('side-panel', ['isOpen']),
        },
        methods: {
            ...mapActions('side-panel', ['toggle']),
        },
    };
</script>
